export const EVENTS_ANALYTICS = {
  OPEN_HOME: 'open_home',
  OPEN_COURSE: 'open_course',
  OPEN_LESSON: 'open_lesson',
  OPEN_CONTENT: 'open_content',
};
